export const Logo = ({ compact = false }) => (
    <span className="inline-flex items-center gap-3" data-testid="brand-logo">
        <svg width="38" height="38" viewBox="0 0 64 64" aria-hidden="true">
            <rect width="64" height="64" rx="14" fill="#0A0A0C" stroke="rgba(212,175,55,0.4)" strokeWidth="1" />
            <circle cx="32" cy="32" r="21" fill="none" stroke="#D4AF37" strokeWidth="1.4" />
            <text x="32" y="40" fontFamily="Cinzel, Georgia, serif" fontSize="20" fill="#D4AF37" textAnchor="middle">TV</text>
        </svg>
        {!compact && (
            <span className="leading-none">
                <span className="block font-sub tracking-[0.28em] text-sm text-amber-100">TOURVOYAGERS</span>
                <span className="block text-[9px] tracking-[0.34em] text-amber-500/80 mt-1">TRAVEL DIFFERENTLY</span>
            </span>
        )}
    </span>
);
